import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../components/Layout/DefaultWrapper';
import MenuOpener from '../../components/MenuOpener';
import Footer from '../../components/Layout/Footer';

// Screens
import Feature from './screens/Feature';
import Brochure from './screens/Brochure';
import Manifesto from './screens/Manifesto';
import SpecificsScreen from './screens/Specifics';
import FooterScreen from './screens/Footer';

const Services = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    {/* Screens */}
    <Feature />
    <Brochure />
    <Manifesto />
    <SpecificsScreen />
    <FooterScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(Services);



// WEBPACK FOOTER //
// ./src/pages/Services/index.jsx